import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default class VideoFile extends Icon {
  gradientId = this.getRandomId();

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient
          id={this.gradientId}
          x1="2.99%"
          x2="100%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#6C3D95" />
          <stop offset="100%" stopColor="#592E84" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" opacity={this.props.opacity}>
        <rect width="40" height="40" fill={`url(#${this.gradientId})`} rx="5" />
        <path
          fill="#FFF"
          d="M13.458 32c-.239 0-.477-.054-.69-.162-.476-.27-.768-.755-.768-1.32V9.495c0-.539.292-1.05.769-1.32.477-.27 1.06-.216 1.51.08l15.085 10.512c.397.27.636.727.636 1.212 0 .486-.239.944-.636 1.213L14.28 31.703c-.239.216-.53.297-.822.297z"
        />
      </g>
    </svg>
  );
}

VideoFile.defaultProps = {
  opacity: '1.0',
};

VideoFile.propTypes = {
  opacity: PropTypes.string,
};
